import React from "react";
import { Box, Radio } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicRadioDisabled = () => {
  return (
    <Box sx={{ mb: 2 }}>
      <PreviewAndEditor  language={"js"} value={"        <Radio disabled size=\"large\" />\n" +
          "        <Radio disabled checked size=\"large\" />"}>
        <Radio disabled size="large" />
        <Radio disabled checked size="large" />
      </PreviewAndEditor>
    </Box>
  );
};

export default BasicRadioDisabled;
